import React, { useEffect, useState } from 'react';
import { authAPI } from '../../services/api';
import {
  getStoredPhoneExtension,
  setExtensionConfirmedThisSession,
  setStoredPhoneExtension,
} from '../../utils/screenPopAccess';

interface ExtensionPromptModalProps {
  initialExtension?: string;
  onConfirmed: (extension: string) => void;
}

const ExtensionPromptModal: React.FC<ExtensionPromptModalProps> = ({
  initialExtension,
  onConfirmed,
}) => {
  const [extension, setExtension] = useState(
    (initialExtension || getStoredPhoneExtension() || '').trim()
  );
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setExtension((initialExtension || getStoredPhoneExtension() || '').trim());
  }, [initialExtension]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const ext = extension.trim();
    if (!/^\d{2,6}$/.test(ext)) {
      setError('شماره داخلی باید بین ۲ تا ۶ رقم باشد.');
      return;
    }

    setSaving(true);
    setError(null);
    try {
      await authAPI.updateMyExtension(ext);
      setStoredPhoneExtension(ext);
      setExtensionConfirmedThisSession(true);
      onConfirmed(ext);
    } catch (err: any) {
      const detail = err?.response?.data?.detail;
      const raw = typeof detail === 'string' ? detail : '';
      const lowered = raw.toLowerCase();
      if (lowered === 'not authenticated' || err?.response?.status === 401) {
        setError('نشست ورود نامعتبر است. صفحه را تازه کنید و دوباره وارد شوید.');
      } else {
        setError(raw || 'خطا در ذخیره داخلی');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/45 p-4">
      <div
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl"
        style={{ direction: 'rtl' }}
      >
        <div className="mb-4">
          <h3 className="text-lg font-bold text-gray-900">شماره داخلی تلفن</h3>
          <p className="mt-2 text-sm leading-7 text-gray-600">
            برای نمایش تماس‌های ورودی روی پنل، شماره داخلی دستگاه خود را وارد کنید.
            این سؤال در هر ورود پرسیده می‌شود.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              {error}
            </div>
          )}

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">
              داخلی شما چند است؟
            </label>
            <input
              type="text"
              inputMode="numeric"
              autoFocus
              value={extension}
              onChange={(e) => setExtension(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="مثلاً 101"
              className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-base focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-200"
            />
          </div>

          <button
            type="submit"
            disabled={saving}
            className="w-full rounded-lg bg-teal-700 px-4 py-2.5 text-sm font-semibold text-white hover:bg-teal-800 disabled:opacity-60"
          >
            {saving ? 'در حال ذخیره...' : 'تأیید و ادامه'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ExtensionPromptModal;
